module.exports = __webpack_public_path__ + "img/sg45_samurai01_c.8e725d90.png";